import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-navy px-3 py-4 sm:px-6" data-id="element-80" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-2xl items-start gap-2.5 rounded-lg border-2 border-gold bg-navy-soft px-3 py-2.5" data-id="element-81" data-mp="1o3dmib9hgbqm">
        <ShieldCheckIcon className="mt-0.5 h-9 w-9 shrink-0 text-gold" strokeWidth={1.6} aria-hidden="true" data-id="element-82" data-mp="22124nbc614rz" />
        <div data-id="element-83" data-mp="19ehgskuwfat6">
          <h2 className="font-display text-[1.05rem] font-extrabold uppercase leading-none text-white sm:text-[1.45rem]" data-id="element-84" data-mp="19e7q0v214zmf">
            YOUR PURCHASE IS <span className="text-gold" data-id="element-85" data-mp="14h8xui1xf2qv">100% PROTECTED</span>
          </h2>
          <p className="mt-1 text-[0.78rem] leading-[1.35] text-white/80 sm:text-[0.9rem]" data-id="element-86" data-mp="1j5lu7g4xenlw">
            Explore FIBER OPTIC DIAGNOSTIC PRO™ for 7 days. Access the complete 6-module professional diagnostic
            system and all 5 strategic bonuses. If it isn't right for you, contact us within 7 days for a full refund
            according to the refund terms.
          </p>
        </div>
      </div>
    </section>;
}